import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ColorType } from '../../types/misc';
import { COLOR_STYLES, ICONS } from '../../constants/constants';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  protected readonly ICONS = ICONS;

  @Input() color: ColorType = COLOR_STYLES.DARK;
  @Input() closable: boolean = false;

  @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();

  onCloseClick(event: MouseEvent): void {
    event.stopPropagation();
    this.closeClicked.emit();
  }
}
